import clsx from "clsx";
import Link from "next/link";
import React from "react";

import { Icon } from "@afa-shared/afa-components";

import styles from "./index.module.css";

export type StandardLinkProps = {
  text: string;
  url?: string;
  variant?: "link" | "button";
  buttonStyle?: "primary" | "secondary";
  ariaLabel?: string;
  color?: string;
  type?: "open_in_new" | "arrow_forward" | "file_download";
  target?: string;
  className?: string;
  hideIcon?: boolean;
  onClick?: (value?: any) => void;
  testId?: string;
  contentfulEntryId?: string;
  contentfulFieldId?: string;
};

export function StandardLink({
  text,
  variant = "link",
  url,
  ariaLabel,
  color,
  type = "arrow_forward",
  target = "_self",
  className,
  buttonStyle = "primary",
  hideIcon = false,
  onClick,
  testId,
  contentfulEntryId,
  contentfulFieldId,
}: StandardLinkProps): React.ReactNode {
  const classNames = clsx("afa-shared-link", styles.standardLink, className, buttonStyle, variant, {
    "link-external": variant === "link" && type === "open_in_new",
    "link-internal": variant === "link" && type === "arrow_forward",
    "link-file": variant === "link" && type === "file_download",
  });

  if (type === "open_in_new") {
    return (
      <a
        href={url}
        onClick={onClick}
        className={classNames}
        style={{ color }}
        target={target}
        aria-label={ariaLabel}
        data-testid={testId}
        data-contentful-entry-id={contentfulEntryId}
        data-contentful-field-id={contentfulFieldId}
      >
        <span style={{ color }}>{text}</span>
        {!hideIcon && <Icon name={type} size="sm" fill={color} referenceSize="link" />}
      </a>
    );
  }

  return (
    <Link
      href={url}
      prefetch={false}
      onClick={onClick}
      className={classNames}
      style={{ color }}
      target={target || "_self"}
      aria-label={ariaLabel}
      data-testid={testId}
      data-contentful-entry-id={contentfulEntryId}
      data-contentful-field-id={contentfulFieldId}
    >
      {!hideIcon && variant !== "button" && (
        <Icon name={type} size="sm" fill={color} referenceSize="link" />
      )}
      <span style={{ color }}>{text}</span>
    </Link>
  );
}
